<template>
  <v-menu :close-on-content-click="false" nudge-bottom="15" offset-y v-model="visible">
    <template v-slot:activator="{ attrs, on }">
      <div class="filters-container">
        <v-btn v-bind="attrs" v-on="on">
          Filter
          <v-icon>{{ noOfActiveFilters === 0 ? `mdi-filter-outline` : `mdi-filter` }}</v-icon>
        </v-btn>
        <span class="text--disabled pl-2" v-if="noOfActiveFilters > 0"
          >{{ noOfActiveFilters }} aktiva filter</span
        >
      </div>
    </template>
    <v-card class="pa-3 the-card">
      <div class="header-row">
        <div class="overline">Filter</div>
        <div class="body-2 count-info">
          <v-icon small color="green">mdi-information-outline</v-icon>Visar just nu
          {{ meta.totalRecords }} kontakter
        </div>
      </div>
      <div style="display: flex; flex-direction: column; gap: 5px">
        <PreMadeFilter
          :value="onlyShowStatusNew"
          @change="onChangeOnlyNewStatus"
          label="Visa bara nya kontakter"
        />
        <div class="active-filters">
          <ContactFilter
            v-for="(filter, i) in activeFilters"
            :key="i"
            :filter="filter"
            @remove="onRemoveFilter"
            @change="onFilterChange"
          />
        </div>
        <div class="tags-container">
          <v-chip
            v-for="tag in contactTags"
            :title="tag.description"
            :key="tag.id"
            small
            :color="getTagColor(tag.color)"
            label
            :text-color="isTagSelected(tag) ? 'white' : null"
            class="tags"
            :outlined="isTagSelected(tag) ? false : true"
            @click="onSelectTag(tag)"
          >
            {{ tag.name }}
          </v-chip>
        </div>

        <!-- {{ filters }} -->
        <v-card-actions>
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="#145074"
            size="20"
          ></v-progress-circular>
          <v-btn small @click="resetFilters"> Återställ filter </v-btn>
          <v-spacer></v-spacer>
          <v-btn small @click="onAddFilter"> Lägg till filter </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ContactFilter from '@/components/contacts/Filter.vue'
import PreMadeFilter from '@/components/contacts/PreMadeFilter.vue'
import { getTagColor } from '@/assets/data/colors.js'

export default {
  name: 'ContactFilters',
  components: {
    ContactFilter,
    PreMadeFilter,
  },

  data() {
    return {
      visible: false,
      loading: false,
      activeFilters: [],
    }
  },
  computed: {
    ...mapGetters('contacts', { contactTags: 'tags' }),
    ...mapGetters('contacts', { filters: 'getFilters', meta: 'getMeta' }),

    noOfActiveFilters() {
      const numberOfTagsSelected = this.filters.find((f) => f.key === 'contact_tags')
        ? this.filters.find((f) => f.key === 'contact_tags').value.length
        : 0
      const includeOnlyShowStatusNew = this.onlyShowStatusNew ? 1 : 0
      const total = this.activeFilters.length + numberOfTagsSelected + includeOnlyShowStatusNew
      return total
    },
    onlyShowStatusNew() {
      return this.filters.some((f) => f.key === 'contact_status' && f.value === 'new')
    },
  },
  created() {
    this.$nextTick(() => {
      const hideFilters = ['contact_status', 'pageSize', 'pageNumber', 'contact_tags']
      this.activeFilters = this.filters.filter((f) => !hideFilters.includes(f.key))
    })
  },
  methods: {
    getTagColor,
    ...mapMutations('contacts', {
      addFilter: 'ADD_FILTER',
      removeFilter: 'ADD_FILTER',
      clearFilters: 'CLEAR_FILTERS',
    }),
    onChangeOnlyNewStatus(isActive) {
      if (isActive) {
        this.addFilter({ key: 'contact_status', value: 'new' })
        this.$emit('change')
      } else {
        this.removeFilter({ key: 'contact_status', value: null })
        this.$emit('change')
      }
    },
    resetFilters() {
      this.activeFilters = []
      this.clearFilters()
      this.addFilter({ key: 'pageSize', value: 30 })
      this.$emit('change')
    },
    onAddFilter() {
      this.activeFilters.push({ id: crypto.randomUUID() })
    },
    onRemoveFilter({ id, key }) {
      this.activeFilters = this.activeFilters.filter((f) => f.id !== id)
      this.removeFilter({ key, value: null })
      this.$emit('change')
    },
    onFilterChange(filter) {
      this.activeFilters = this.activeFilters.map((f) => (f.id === filter.id ? filter : f))
      this.addFilter(filter)
      this.$emit('change')
    },
    onSelectTag({ id }) {
      let selectedIds = this.filters.find((f) => f.key === 'contact_tags')
        ? this.filters.find((f) => f.key === 'contact_tags').value
        : []

      selectedIds = selectedIds.includes(id)
        ? selectedIds.filter((i) => i !== id)
        : [...selectedIds, id]

      const filter = { key: 'contact_tags', value: selectedIds.length ? selectedIds : null }
      this.addFilter(filter)
      this.$emit('change')
    },
    isTagSelected(tag) {
      return this.filters.find((f) => f.key === 'contact_tags')
        ? this.filters.find((f) => f.key === 'contact_tags').value.includes(tag.id)
        : false
    },
  },
}
</script>

<style lang="less" scoped>
.filters-container {
  display: flex;
  align-items: center;
}
.the-card {
  width: 500px;
}
.active-filters {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .count-info {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: #999;
  }
}

.tags {
  margin-right: 4px;
  margin-bottom: 4px;
  cursor: pointer;
}
</style>
